import { get } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'Comments',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    canGetSendernamesAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.sendernames}.get`, permissionPresets.resellerUp)
    },

    canGetSendernames() {
      return this.checkPermissions(`advanced.${Services.sendernames}.get`, [ false, 'me' ])
    },

    commentFromAdminOrReseller() {
      return get(this.value, 'meta.adminComment') || get(this.value, 'meta.resellerComment')
    },

    showCommentFromAdminOrReseller() {
      let result = false

      if (this.commentFromAdminOrReseller) {
        result = true
      }

      if (this.canGetSendernames) {
        result = true
      }

      return result
    }
  },

  render
}
